
import { effect, HostListener, Injectable } from "@angular/core";
import { ActivatedRoute, NavigationEnd, NavigationStart, Route, Router } from "@angular/router";
import { BehaviorSubject, distinctUntilChanged, noop, tap } from "rxjs";
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, Location } from '@angular/common';
import { BrowserService } from "projects/shared/services/browser.service";
import { Store } from "@ngrx/store";
import { SelectRegionalLanguage } from "../../layout/navbar/components/navbar-header/partials/nav-regional/store/regional-setting.selectors";
import { TranslateService } from "@ngx-translate/core";
import { RegionalActions } from "../../layout/navbar/components/navbar-header/partials/nav-regional/store/regional-setting.actions";
@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  arabic = new BehaviorSubject<boolean>(false);
  selectedCountry = new BehaviorSubject<string>(null!);
  onLoadComplete = new BehaviorSubject<boolean>(true);

  language$ = this._store.selectSignal(SelectRegionalLanguage);

  constructor(
    private _router: Router,
    private _location: Location,
    private _browserService: BrowserService,
    private _store: Store,
    private _translateService: TranslateService
  ) {
    this.getLanguageFromRoute();
    this.routeSubscription()
    effect(() => {
      if (this.language$()) {
        _translateService.use(this.language$())
        this.changeLangToArabic(_browserService.getLocation()?.pathname!);
      }
    })
  }

  getLanguageFromRoute() {
    this._store.dispatch(RegionalActions.changeLanguage({ language: this._browserService.getLocation()?.pathname.split('/')[1]! }))
  }

  routeSubscription() {
    this._router.events.pipe(
      distinctUntilChanged(),
      tap(res => {
        if (res instanceof NavigationEnd) {
          this.changeLangToArabic(res.url)
        }
      })
    ).subscribe();
  }

  changeLangToArabic(url: string) {

    // Fix SSR: check if value exists before parsing
    if (this.language$() && this.language$() !== 'null') {
      try {
        if (this.language$() == 'ar') {
          this._location.go(this.editRoute(url, true))
        }
        else {
          this._location.go(this.editRoute(url, false))
        }
      } catch (e) {
        // Fallback to English if parsing fails
        this._location.go(this.editRoute(url, false))
      }
    }

  }

  private editRoute(route: string, ar: boolean) {
    let u: any = route.split('/');
    u[1] = ar ? 'ar' : 'en'
    return u.join('/').split(',').toString()
  }
}


